jQuery( ".mobile-toggle button" ).click(function() {
	
  jQuery( ".top-nav" ).toggleClass( 'menu-open' );
  
});